import {
  INPUT_MANAGEMENT_METER_DAY_MODEL_LIST,
  INPUT_MANAGEMENT_METER_DAY_SEARCH,
  INPUT_MANAGEMENT_METER_DAY_PAGINATION,
  INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_TYPE,
  INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_SOURCE,
} from "./actionType";

import moment from 'moment';

const initialState = {
  modelDeviceList: [],
  modelSearch: { UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, SOURCE_NAME: null, STATUS_FLAG: 0, LOAD_TYPE: 0 },
  dropDownSearchType: null,
  dropDownSearchDataSource: null,
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  // console.log(action);
  switch (action.type) {
    case INPUT_MANAGEMENT_METER_DAY_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case INPUT_MANAGEMENT_METER_DAY_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case INPUT_MANAGEMENT_METER_DAY_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    case INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_TYPE:
      return {
        ...state,
        dropDownSearchType: action.payload,
      }
    case INPUT_MANAGEMENT_METER_DAY_DROP_DOWN_SEARCH_SOURCE:
      return {
        ...state,
        dropDownSearchDataSource: action.payload,
      }
    default:
      return state;
  }
};
